module.exports = __webpack_public_path__ + "static/img/1099@2x.53f6e5fb.png";